

























import Vue from 'vue'
import { Component } from '@niknevis/vue-modules'
import BaseCard from '@/modules/shared/components/shared/base/BaseCard.vue'
import Toggle from '@/modules/shared/components/shared/kit/Toggle.vue'
import { Prop } from 'vue-property-decorator'

@Component({
  components: { Toggle, BaseCard }
})
export default class NotificationToggleButton extends Vue {
  @Prop({ required: true }) label!: string
  @Prop({ default: 'ion notifications-circle-outline' }) icon!: string
  @Prop({ required: true }) property!: string
  @Prop() notificationStatus!: boolean
  @Prop() verificationStatus!: boolean
}
